import React from 'react'
import PropTypes from 'prop-types'
import { ResponsiveIframe } from 'scripts/helpers/AppHelper'

const GenericHeroIframe = (props) => {
  const { src } = props

  return (
    <div className='article-iframe-hero'>
      <ResponsiveIframe src={ src }></ResponsiveIframe>
    </div>
  )
}
export default GenericHeroIframe

GenericHeroIframe.propTypes = {
  src: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./assets/js/components/article/HeroIframe/GenericHeroIframe.jsx